var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarWithDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 1.99992H4C2.89543 1.99992 2 2.89535 2 3.99992V5.99992M5.33333 1.99992V1.33325M5.33333 1.99992H10.6667M5.33333 1.99992V2.66659M10.6667 1.99992H12C13.1046 1.99992 14 2.89535 14 3.99992V5.99992M10.6667 1.99992V1.33325M10.6667 1.99992V2.66659M2 5.99992V12.6666C2 13.7712 2.89543 14.6666 4 14.6666H12C13.1046 14.6666 14 13.7712 14 12.6666V5.99992M2 5.99992H14M9 8.33325H11L9.33333 11.6666M7 9.33325V10.6666C7 11.2189 6.55228 11.6666 6 11.6666C5.44772 11.6666 5 11.2189 5 10.6666V9.33325C5 8.78097 5.44772 8.33325 6 8.33325C6.55228 8.33325 7 8.78097 7 9.33325Z",
    stroke: "#808897",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWithDate);
export default __webpack_public_path__ + "static/media/CalendarWithDate.3583c033052f99401b6323413bd88f70.svg";
export { ForwardRef as ReactComponent };